export default {
  fields: {
    issuer_type: {
      readOnly: true,
    },
    issuer_id: {
      readOnly: true,
    },
    user_id: {
      readOnly: true,
    },
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    }
  },
  relationships: {
    user: {
      type: 'users',
    },
    issuer: {
      polymorphic: true,
    }
  }
}
